export default __webpack_public_path__ + "static/media/seat-lounger-selected.168ca105.svg";